import { render, staticRenderFns } from "./ArtistVideoSection.vue?vue&type=template&id=034dcf38&scoped=true&"
import script from "./ArtistVideoSection.vue?vue&type=script&lang=js&"
export * from "./ArtistVideoSection.vue?vue&type=script&lang=js&"
import style0 from "./ArtistVideoSection.vue?vue&type=style&index=0&id=034dcf38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034dcf38",
  null
  
)

export default component.exports